import { lazy } from 'react';

export default [
    {
        path: '/chuankanng',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'MangaChatLayout' */ './layout')),
    },
];
